var _ellipse, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocN(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.8797,
    cy: 11.0346,
    rx: 10.8797,
    ry: 11.0346,
    fill: "#4D6994",
    fillOpacity: 0.07
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8147 8.97193C15.2135 6.28879 12.9058 5.08079 10.8788 5.08079C10.8788 5.08079 10.8788 5.08079 10.873 5.08079C8.85171 5.08079 6.53833 6.28298 5.93709 8.96613C5.26713 11.9629 7.0766 14.5008 8.71428 16.098C9.32125 16.6903 10.1 16.9865 10.8788 16.9865C11.6575 16.9865 12.4363 16.6903 13.0375 16.098C14.6752 14.5008 16.4847 11.9687 15.8147 8.97193ZM10.8788 11.8816C9.88242 11.8816 9.07503 11.0627 9.07503 10.0522C9.07503 9.04163 9.88242 8.22274 10.8788 8.22274C11.8751 8.22274 12.6825 9.04163 12.6825 10.0522C12.6825 11.0627 11.8751 11.8816 10.8788 11.8816Z",
    fill: "#4D6994"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocN);
export default __webpack_public_path__ + "static/media/loc-n.398c52690e0fc22c9111431709ae1564.svg";
export { ForwardRef as ReactComponent };